import useMutationVariationCreateUpdate from "./variation-use-mutation-create-update";
import useMutationVariationDelete from "./variation-use-mutation-delete";

export const variationUseMutation = {
  createUpdate: useMutationVariationCreateUpdate,
  delete: useMutationVariationDelete,
};
